import axios from "axios";

export function getAllConventions() {
  return axios({
    method: "GET",
    url: "/api/Convention/All",
  });
}

export function getActiveConvention(){
  return axios({
    method: "GET",
    url: "/api/Convention/Active",
  });
}

export function setNewActiveConvention(convention: object) {
  return axios({
    method: "POST",
    url: "/api/Security/UpdateConventionClaim",
    data: convention,
  });
}
